import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { PromotionsCarouselComponent } from './promotions-carousel.component';

@NgModule({
  declarations: [PromotionsCarouselComponent],
  imports: [CommonModule, MatIconModule],
  exports: [PromotionsCarouselComponent],
})
export class PromotionsCarouselModule {}
